import { render } from "./CompanySectionForm.vue?vue&type=template&id=47ad6f1e"
import script from "./CompanySectionForm.vue?vue&type=script&lang=js"
export * from "./CompanySectionForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__